export default __webpack_public_path__ + "static/media/threat_and_vulnerability_management.b2004539.png";